const urlRegex = new RegExp("^(?:[a-z]+:)?//", "i");
export function isAbsoluteUrl(data) {
  return urlRegex.test(data);
}
export function isString(data) {
  return typeof data === "string";
}
export function isNumeric(data) {
  return typeof data === "number";
}
export function isValidUrl(data) {
  try {
    new URL(data);
    return true;
  } catch {
    return false;
  }
}